import { isRequired } from '@gef-ui/form-core/validations/validationFunctions/common';

import { isDateWithOrder, isFullySpecifiedDate } from 'app/forms/validations/common';
import isCampaignName from 'app/forms/validations/isCampaignName';
import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

export const NEW_CAMPAIGN_FORM_NAME = 'newCampaign-filter';

const { channel, campaignName, communicationName, campaignType, startDate, endDate } = COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	campaignName,
	channel,
	communicationName,
	campaignType,
	startDate,
	endDate,
};

export default () => ({
	[FIELDS.campaignName]: {
		deepPath: [FIELDS.campaignName],
		validations: [isRequired(), isCampaignName()],
	},
	[FIELDS.channel]: {
		deepPath: [FIELDS.channel],
		validations: [isRequired()],
	},
	[FIELDS.communicationName]: {
		deepPath: [FIELDS.communicationName],
		validations: [isRequired(), isCampaignName()],
	},
	[FIELDS.campaignType]: {
		deepPath: [FIELDS.campaignType],
		validations: [isRequired()],
	},
	[FIELDS.startDate]: {
		deepPath: [FIELDS.startDate],
		dependentFields: [FIELDS.endDate],
		validations: [
			isRequired(),
			isFullySpecifiedDate(),
			isDateWithOrder({ fromFieldName: FIELDS.startDate, toFieldName: FIELDS.endDate }),
		],
	},
	[FIELDS.endDate]: {
		deepPath: [FIELDS.endDate],
		dependentFields: [FIELDS.startDate],
		validations: [
			isRequired(),
			isFullySpecifiedDate(),
			isDateWithOrder({ fromFieldName: FIELDS.startDate, toFieldName: FIELDS.endDate }),
		],
	},
});
